import type { ComponentType } from 'react';

/** Account settings tabs whose content comes from a package above `user-ui`. */
export type RegisteredAccountSettingsTab = 'connections';

const registeredTabs = new Map<RegisteredAccountSettingsTab, ComponentType>();

/**
 * Registers the content component for an account settings tab. Each app calls this from
 * its `initPackages`.
 * @param tab Tab value, as used in the `/user/settings/connections` route.
 * @param component Component that renders the tab content.
 */
export function registerAccountSettingsTab(
  tab: RegisteredAccountSettingsTab,
  component: ComponentType,
): void {
  registeredTabs.set(tab, component);
}

/**
 * Returns the content component registered for an account settings tab.
 * @param tab Tab value.
 * @returns The registered component, or `undefined` when the app registered none.
 */
export function getAccountSettingsTab(
  tab: RegisteredAccountSettingsTab,
): ComponentType | undefined {
  return registeredTabs.get(tab);
}
